import { useRef } from 'react';
import CountUp from 'react-countup';

import { CASE_LIST, COUNT_ARR, PC_SWIPE_LIST } from '@portalCommon/constants';
import { useFirstInView } from '@fuxi/eevee-hooks';

import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import { BillboardScroll } from '@/components';

import styles from './index.module.less';

const cx = classnames.bind(styles);

const CaseList = () => {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <section className={cx('client-choose-list')} ref={ref}>
      {CASE_LIST.map((item, index) => (
        <div className={cx('list-item')} key={index}>
          <div className={cx('item-head')}>
            <div className={cx('item-head-left')}>
              <OptimizedImg loading="lazy" src={item.poster} alt={item.poster} />
            </div>
            <div className={cx('item-head-right')}>
              <p>{item.title}</p>
              <p>
                {item.tags.map(tag => (
                  <span key={tag + index}>{tag}</span>
                ))}
              </p>
            </div>
          </div>
          <p className={cx('item-center')}>{item.desc}</p>
          <ul>
            {item.liList.map((liItem, liIndex) => (
              <li key={liItem + liIndex} dangerouslySetInnerHTML={{ __html: liItem }}></li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
};

const CountCop = () => {
  const countRef = useRef<HTMLDivElement>(null);
  const inViewport = useFirstInView(countRef);

  const formatNumber = (value: number) => {
    return String(value).replace(/,/g, '');
  };

  return (
    <section className={cx('client-choose-count')} ref={countRef}>
      {COUNT_ARR.map((item, index) => (
        <dl key={index}>
          <dt>
            {inViewport ? (
              <CountUp duration={1} start={item.start} formattingFn={formatNumber} end={item.count} />
            ) : (
              item.count
            )}
            {item.unit && <span className={cx('unit')}>{item.unit}</span>}
          </dt>
          <dd>{item.text}</dd>
        </dl>
      ))}
    </section>
  );
};

const ScrollLogo = () => {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <section className={cx('client-choose-scroll')} ref={ref}>
      {PC_SWIPE_LIST.map((item, index) => (
        <div key={index} className={cx('client-choose-logo')}>
          <BillboardScroll identifyFlag="distributor-case" height={110} speed={item.speed} width={2540} key={index}>
            {item.list.map(chidItem => (
              <OptimizedImg loading="lazy" src={chidItem} alt={chidItem} key={chidItem} />
            ))}
          </BillboardScroll>
        </div>
      ))}
    </section>
  );
};
// 客户选择
export function ClientChoose() {
  return (
    <section className={cx('client-choose')}>
      <CaseList />
      <CountCop />
      <ScrollLogo />
    </section>
  );
}
